<template>
  <div class="service_box safe-distance-top-header-two">
    <Header :pageTitle="$route.meta.title">
      <template #right>
        <p
          v-show="$route.meta.canToAgain"
          class="again_btn"
          @click="againDialog = true"
        >
          重新签约
        </p>
      </template>
    </Header>
    <router-view></router-view>
    <van-dialog
      class="again_dialog_box"
      v-model="againDialog"
      :showConfirmButton="false"
    >
      <p class="again_dialog_text">是否确认放弃本次签约，重新进行签约？</p>
      <div class="again_btn_box">
        <van-button class="again_dialog_btn" round @click="againDialog = false"
          >取消</van-button
        >
        <van-button
          class="again_dialog_btn"
          type="info"
          round
          @click="againSign"
          >确认</van-button
        >
      </div>
    </van-dialog>
    <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
export default {
  name: "ServiceSign",
  components: {
    Header,
  },
  data() {
    return {
      againDialog: false,
    };
  },
  methods: {
    againSign() {
      let type = this.$route.query.type;
      let out = this.$route.query.out;
      this.$router.replace({
        path: "/service-sign/form-service",
        query: {
          type,
          out,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.service_box {
  padding-top: 44px;
  min-height: 100vh;
}
.again_btn {
  font-size: 15px;
  color: #333333;
}
.again_dialog_box {
  padding: 22px 20px 25px;
  .again_dialog_text {
    margin-bottom: 25px;
    font-size: 14px;
    color: #333333;
    line-height: 21px;
  }
  .again_btn_box {
    display: flex;
    justify-content: space-between;
    .again_dialog_btn {
      width: 130px;
      height: 40px;
      // &:nth-child(2n) {
      //   margin-left: 15px;
      // }
    }
  }
}
</style>
